import styled from 'styled-components';
import { rtl } from '../../utils/language';
import { titleStyles } from '../common/styles';

export const Title = styled.div.attrs(({ className }) => ({ className }))`
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid var(--light-gray-border);
  ${titleStyles} ${rtl`
    font-family: Tajawal;
  `};
`;

export const FormRow = styled.div`
  margin-bottom: 24px;
  display: flex;

  > div:not(:last-child) {
    margin-right: 16px;

    ${rtl`
       margin-right: 0px;
       margin-left: 16px;
  `};
  }
`;

export const Required = styled.div`
  font-weight: 700;
  line-height: 20px;
  font-size: 16px;
  font-family: var(--font-family-signika);
  color: var(--error-100);
  display: inline-flex;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const FormField = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  line-height: normal;

  ${({ disabled }) =>
    disabled &&
    `
    opacity: 0.5;
  `};
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 150px 0 32px 0;

  button:not(:last-child) {
    margin-right: 16px;

    ${rtl`
        margin-right: 0px;
        margin-left: 16px;
    `};
  }

  span:not(:last-child) {
    margin-right: 16px;

    ${rtl`
        margin-right: 0px;
        margin-left: 16px;
    `};
  }

  button {
    ${rtl`
        font-family: Tajawal !important;
    `};
  }
`;

export const ModalContent = styled.div`
  margin: 30px 0;
`;

export const UploaderWrapper = styled.div`
  width: 100%;
`;
